import { axiosInstance } from '@/lib/axios'

export interface EditCompanyRequest {
  id: string | number
  companyName: string
  invoiceCompanyName?: string | null
  nip?: string
  regon?: string
  krs?: string
  email?: string
  notificationsEmail?: string
  contactEmail?: string
  contactCCEmail?: string
  contactPhone?: string
  licenseNumber?: string
  street?: string
  houseNumber?: string
  buildingNumber?: string
  postalCode?: string
  city?: string
  [key: string]: any
}

export function editCompany(payload: EditCompanyRequest) {
  return axiosInstance.post('/config-api/company/edit', payload)
}

export function getCompanyConfigDetails(companyId: string | number) {
  return axiosInstance.get(`/config-api/company/${companyId}/?&ignoreMigration=true`)
}
